/** Set before cross-origin navigation to Studio — Academy must re-fetch auth on return. */
export const ACADEMY_AUTH_RESYNC_KEY = 'academy_auth_resync';

export function markAcademyAuthResync(): void {
  sessionStorage.setItem(ACADEMY_AUTH_RESYNC_KEY, '1');
}

export function shouldAcademyAuthResync(): boolean {
  return sessionStorage.getItem(ACADEMY_AUTH_RESYNC_KEY) === '1';
}

export function consumeAcademyAuthResync(): boolean {
  if (!shouldAcademyAuthResync()) return false;
  sessionStorage.removeItem(ACADEMY_AUTH_RESYNC_KEY);
  return true;
}
